import { useContext } from "react";
import { RepositoryContext } from "./Repository";
import { IRepository } from "./types";

export const useRepositoryContext = <TConcreteRepository extends IRepository>() =>
    useContext(RepositoryContext) as TConcreteRepository;

export default useRepositoryContext;
